<script>
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  export let userSelectionOrder;
  export let milkTypeOfSchool;
  export let orderFrame;

  import milkOptionsStore from "../../stores/milkOptions-store.js";
  $: availableMilkOptions = $milkOptionsStore[milkTypeOfSchool].options;

  const toEuro = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });

  let lastKnownBaseSum;

  function calcBaseSum(availableMilkOptions, userSelectionOrder, orderFrame) {
    let runningSum = 0;
    let weekNo;
    for (weekNo in userSelectionOrder.weekSlices) {
      let weekSlice = orderFrame.weekSlices.find(el => el.weekNo == weekNo);
      let milkOption = availableMilkOptions.find(el => el.code == userSelectionOrder.weekSlices[weekNo]);
      runningSum = runningSum + milkOption.pricePerDay * weekSlice.adjustedSchoolDays;
    }
    if (lastKnownBaseSum != runningSum) {
      lastKnownBaseSum = runningSum;
      dispatch("newBaseSum", runningSum)
    }
  }

  $: calcBaseSum(availableMilkOptions, userSelectionOrder, orderFrame);
</script>

<div class="paymentAmount">
  <div>
    <div>Bestellung</div>
    <div>{toEuro.format(userSelectionOrder.baseSum)}</div>
  </div>
  <div>
    <div>Heldengebühr</div>
    <div>+ {toEuro.format(userSelectionOrder.heroFee)}</div>
  </div>
  <div>
    <div>Gesamtsumme</div>
    <div>{toEuro.format(userSelectionOrder.totalSum)}</div>
  </div>
</div>

<style>
  div.paymentAmount {
    margin-right: 100px;
    width: 220px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  div.paymentAmount > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  div.paymentAmount > div > div:nth-child(1) {
    font-weight: 300;
  }
  div.paymentAmount > div > div:nth-child(2) {
    font-weight: bold;
  }


  div.paymentAmount > div:nth-child(2) {
    border-bottom-style: solid;
    border-color: white;
    border-width: 1.8px;
    padding-bottom: 3px;
    margin-bottom: 3px;
  }
  div.paymentAmount > div:nth-child(3) {
    border-bottom-style: double;
    border-color: white;
    border-width: 4px;
    padding-bottom: 3px;
  }

  @media screen and (max-width: 500px) {
    div.paymentAmount {
      margin-right: 0;
    }
  }
</style>
